<template >
    <Navigation
        class="d-flex"
        :navigationItemList="confTourModelsItems"
        :data="data"
        @selectNavigationItem="setActiveItem"
    />
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Navigation from '@/layout/alternative/layout/components/Navigation.vue';

    export default {
        name: "ConfTourModelsBody",
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        components:{
            Navigation,
        },
        computed:{
            confTourModelsItems() {
                return this.$props.data ? this.$props.data.items : {};
            }
        },
        methods: {
            setActiveItem(currentItem) {
                if (!currentItem.active)
                    this.data.items.forEach(item => {
                        item.active = currentItem.link === item.link;
                    });

                EventBus.$emit('updateLoadedWidgets', {
                    id: "conf-models",
                    link: currentItem.link,
                    active: true,
                    widgetType: "conf-models"
                });
            },  
        }
    }
</script>



// WEBPACK FOOTER //
// src/layout/alternative/configurableTour/components/ConfTourModelsBody.vue